<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_5001_3338)">
      <path d="M2 14.5C2 16.9853 4.01472 19 6.5 19H18.5C20.433 19 22 17.433 22 15.5C22 13.7367 20.6961 12.278 18.9999 12.0354C19.009 10.2322 18.3256 8.4261 16.9497 7.05025C14.2161 4.31658 9.78392 4.31658 7.05025 7.05025C6.15091 7.9496 5.54744 9.03278 5.23984 10.1788C3.36791 10.7238 2 12.4522 2 14.5Z" stroke="#292929" stroke-width="2" stroke-linejoin="round"/>
      <path d="M14 11L12 9M12 9L10 11M12 9L12 15" stroke="#292929" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
  </svg>
</template>